module.exports = __webpack_public_path__ + "static/media/insights-empty.fe677953.png";